
import { Component, OnInit } from '@angular/core';
import { DefaultCellRendererComponent } from '../../shared/components/table-view/table-view-component-base';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TestSeqService } from '../../core/services/test-seq.service';
import { PathTestService } from '../../core/services';
import { AppState } from '../../core';
import { MissingHandset } from '../../core/models/missing-handset';

@Component({
    selector: '[fes-missing-handset-table-cell-renderer]',
    templateUrl: 'missing-handset-table-cell.component.html',
    styleUrls: ['missing-handset-table-cell.component.scss'],
    host: { '[class]': "cellClass" }
  })
  export class MissingHandsetTableCellComponent extends DefaultCellRendererComponent<MissingHandset> implements OnInit {
    
    cellClass: string

    constructor( 
          public testSeqService: TestSeqService,
          public pathTestService: PathTestService,
          public appState: AppState,
          public modalService: BsModalService){
      super()
    }

    ngOnInit(): void {      
      if ( this.column.name == 'carrier' ) {
        const carrierCssName = 'carrier carrier-' + (this.record['carrier']?.toLowerCase()?.replace(/[\-&]/g,'')||'')
        this.cellClass = this.column.dataCellCssClass ? 
            this.column.dataCellCssClass  + ' ' + carrierCssName : carrierCssName
      }      
    }


    //showPointId(record:DialerCallLogRecord){
    //  this.showRequestEmitter.next( new ShowRequest('tab', 'point', record.pointid, null))
    //}

  }